import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'common/BaseComponent.js';
import moment from "moment";

export default class CommentList extends BaseComponent {

    focus = () => {
        this.icon.focus();
    };

    render() {
        return (
            <div className={this.props.className}>
                <h2>{this.props.header}</h2>
                <a href="#" onClick={this.props.onClick()} ref={(icon) => this.icon = icon} title={this.props.hint}>
                    <img src={this.props.icon} alt=""/>
                </a>
                <div tabIndex="0">
                    <ul>
                        {this.props.value.map((comment, idx) => {
                            return (
                                <li key={idx}>
                                    [{comment.author ? comment.author + " " : ""}{moment(comment.created).format('DD.MM.YY, HH:mm')}] {comment.value}
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}

CommentList.propTypes = {

    /**
     *  Comment objects array, object contain author, text value and creation time by comment
     */
    value: PropTypes.array.isRequired,

    /**
     * Comment list header
     */
    header: PropTypes.string.isRequired,

    /**
     * CSS class name
     */
    className: PropTypes.string.isRequired,

    /**
     * Function, set popup visible
     */
    onClick: PropTypes.func.isRequired,

    /**
     * Image of loupe icon.
     */
    icon: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/CommentList/index.js